export const housekeeping = {
  // ── Page (index) ──
  title: "Housekeeping",
  remindersBtn: "Erinnerungen",
  refresh: "Aktualisieren",
  aboutToLeaveTitle: "Gäste, die heute abreisen",
  aboutToLeaveCount: "{count} reisen ab",
  remindersTitle: "Reinigungserinnerungen einrichten",

  headline: {
    allDone: "Alles erledigt! Derzeit gibt es nichts zu reinigen.",
    inProgress: "Reinigung läuft · {count} in Arbeit",
    toClean: "Was muss heute gereinigt werden? {count} zu reinigen",
    toCleanWithProgress: "Was muss heute gereinigt werden? {toClean} zu reinigen · {inProgress} in Arbeit",
  },

  allProperties: "Alle Unterkünfte",
  searchPlaceholder: "Zimmer, Gast suchen…",

  // Status filter chips (label)
  chips: {
    all: "Alle",
    to_clean: "Zu reinigen",
    in_progress: "In Arbeit",
    occupied: "Belegt",
    clean: "Verfügbar",
    out_of_service: "Außer Betrieb",
  },
  // Status filter chips (tooltip)
  chipTips: {
    all: "Alle Bereiche von heute, ohne Filter.",
    to_clean: "Reinigung ausstehend: als schmutzig markiert, heute abreisend und nicht gereinigt oder Langzeitaufenthalte, die laut Intervall fällig sind.",
    in_progress: "Reinigung läuft gerade.",
    occupied: "Gast im Zimmer (Aufenthalt läuft, keine Abreise heute).",
    clean: "Sauber und bereit für den nächsten Gast (einschließlich der geprüften).",
    out_of_service: "Nicht zur Reinigung verfügbar (Störung oder Wartung).",
  },

  loadingBoard: "Board wird geladen…",
  emptyToClean: "Alles sauber! Derzeit stehen keine Bereiche aus.",
  emptyStatus: "Keine Bereiche in diesem Status.",
  emptySearch: "Keine Bereiche passen zu Ihrer Suche.",

  typeHotel: "Hotel",
  typeApartment: "Apartment",

  // Row badges
  stayDue: "Reinigung fällig",
  hourlyStayDue: "Stundenaufenthalt beendet",
  hourlyStayAt: "Ging um {time}",
  overdue: "Überfällig",
  overdueSince: "Seit {date} nicht gereinigt · {days} Tage",
  overdueGuests: "{n} Gäste sind abgereist, ohne dass eine Reinigung erfasst wurde",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "Von {from} bis {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "Zeit überschritten",
  alreadyLeft: "Bereits abgereist",
  aboutToLeave: "Reist gleich ab",
  cleanBadge: "Sauber",
  inspectedBadge: "Geprüft",

  // Turnover (one leaves / another arrives)
  departs: "↑ Ab",
  arrives: "↓ An",
  guestFallback: "Gast",
  departsOn: "· reist {date} ab",

  // Row actions
  assign: "Zuweisen",
  reassignTitle: "Reinigungszuständigkeit ändern",
  assignWhoTitle: "Reinigungszuständigkeit zuweisen",
  start: "Starten",
  startTitle: "Als in Arbeit markieren",
  cleanAction: "Reinigen",
  cleanTitle: "Reinigung abschließen (Fotos und Notizen)",
  tasks: "Aufgaben",
  tasksTitle: "Aufgaben und Details",

  toastSaved: "Reinigungserinnerungen aktualisiert",

  // Effective status (label)
  status: {
    to_clean: "Zu reinigen",
    in_progress: "In Arbeit",
    occupied: "In Nutzung",
    clean: "Verfügbar",
    inspected: "Geprüft",
    out_of_service: "Außer Betrieb",
  },
  // Effective status (tooltip)
  statusTip: {
    to_clean: "Wartet auf Reinigung.",
    in_progress: "Reinigung läuft.",
    occupied: "In Nutzung: Gast im Zimmer.",
    clean: "Sauber und bereit für den nächsten Gast.",
    inspected: "Sauber und von einer Aufsicht geprüft.",
    out_of_service: "Außer Betrieb: kann nicht gereinigt werden (Störung/Wartung).",
  },
  // Occupancy (label)
  occupancy: {
    vacant: "Frei",
    occupied: "Belegt",
    departure_today: "Abreise heute",
    arrival_today: "Anreise heute",
    turnover: "Abreise und Anreise",
  },
  // Occupancy (tooltip)
  occupancyTip: {
    vacant: "Kein Gast: frei.",
    occupied: "Gast im Zimmer (Aufenthalt läuft).",
    departure_today: "Der Gast reist heute ab: Reinigung wird nötig.",
    arrival_today: "Heute reist ein Gast an: muss rechtzeitig bereit sein.",
    turnover: "Heute reist ein Gast ab und ein anderer an: dringende Reinigung dazwischen.",
  },

  roles: {
    limpieza: "Reinigung",
    mantenimiento: "Wartung",
    recepcion: "Rezeption",
    gestor: "Verwalter",
    propietario: "Eigentümer",
  },

  // Mid-stay cleaning reason
  stayTip: {
    fallback: "Zwischenreinigung fällig",
    daysSince: "{count} Tag | {count} Tage",
    interval: "täglich | alle {count} Tage",
    main: "Der Gast wohnt noch hier. {since} ohne Reinigung, fällig {interval}.",
  },

  // Cleaning-window timer
  timer: {
    approx: " (ca.)",
    overdue: "Anreise überfällig",
    overdueTitle: "Die Anreisezeit ({checkin}) ist vorbei · diese Reinigung priorisieren",
    remaining: "{dur} bis zur Anreise",
    remainingTitle: "Noch {dur} bis zur Anreise ({checkin})",
  },

  // ── Reminders modal ──
  remind: {
    title: "Reinigungserinnerungen",
    subtitle: "Benachrichtigen Sie Ihr Team, wenn ein Zimmer mit bevorstehender An- oder Abreise nicht bereit ist.",
    close: "Schließen",
    scopeLabel: "Welche Unterkünfte?",
    scopeOne: "Diese Unterkunft",
    scopeAll: "Alle",
    summary: "{enabled} von {total} Unterkünften mit aktiven Erinnerungen.",
    propertyLabel: "Unterkunft",
    activeSuffix: " · aktiv",
    propertyHelp: "Jede Unterkunft hat ihren eigenen Zeitplan.",
    allNotePre: "Dieselben Einstellungen gelten für Ihre ",
    allNotePost: " Unterkünfte (jeweils in ihrer Ortszeit).",
    arrivalsTitle: "An- und Abreisen",
    longStayTitle: "Langzeitbuchungen",
    daysBeforeLabel: "Wie lange im Voraus?",
    daysBefore: {
      same: "Nur am selben Tag",
      upTo: "Bis zu {count} Tag vorher | Bis zu {count} Tage vorher",
    },
    daysBeforeHelp: "Berücksichtigt An- und Abreisen in diesem Zeitfenster.",
    intervalLabel: "Wie viele Tage zwischen den Reinigungen?",
    interval: "Täglich | Alle {count} Tage",
    intervalHelp: "Gezählt ab der letzten Reinigung. Das Zimmer erscheint unter „Zu reinigen“, auch wenn es noch belegt ist.",
    timeLabel: "Um welche Uhrzeit werden sie gesendet?",
    timeHelp: "Ortszeit der Unterkunft. Einmal täglich.",
    recipientsLabel: "Wer wird benachrichtigt?",
    note: "Der Versand erfolgt über eine Warteschlange (Benachrichtigung + Push), und jeder Hinweis wird in den Benachrichtigungen protokolliert.",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    saveAll: "Für alle speichern",
    save: "Speichern",
    recipients: {
      assigned: "Zugewiesene",
      team: "Team",
      both: "Beide",
    },
    recipientHelp: {
      assigned: "Nur die diesem Zimmer zugewiesenen Personen.",
      team: "Das gesamte Reinigungs- und Wartungsteam der Unterkunft.",
      both: "Die zugewiesenen Personen und das Team der Unterkunft.",
    },
    longStayOff: "Deaktiviert",
    longStaySub: "Jeden Tag des Aufenthalts | Alle {count} Tage des Aufenthalts",
    toggleAllOn: "Wird für alle aktiviert",
    toggleAllOff: "Wird für alle deaktiviert",
    toggleOneOn: "Für diese Unterkunft aktiviert",
    toggleOneOff: "Deaktiviert",
  },

  // ── Complete-cleaning modal ──
  complete: {
    title: "Reinigung abschließen",
    dropStrong: "Fotos hierher ziehen",
    dropRest: "oder klicken zum Auswählen",
    dropHint: "Nachweis des Zimmerzustands · JPG, PNG, WEBP",
    photoAlt: "Foto",
    saved: "Gespeichert",
    view: "Ansehen",
    remove: "Entfernen",
    notes: "Notizen",
    notesPlaceholder: "Probleme, Schäden, fehlende Gegenstände… (optional)",
    cancel: "Abbrechen",
    uploading: "Wird hochgeladen… {pct}%",
    saving: "Wird gespeichert…",
    submit: "Als sauber markieren",
    previewAlt: "Vorschau",
  },

  // ── Assign modal ──
  assignModal: {
    title: "Wer reinigt diesen Bereich?",
    allOption: "Alle",
    allDesc: "Sichtbar für das gesamte Reinigungs- und Wartungspersonal",
    roleSection: "Einer Rolle zuweisen",
    peopleTitle: "Oder Personen auswählen",
    peopleHint: "(eine oder mehrere)",
    emptyPre: "Sie haben noch keine Teammitglieder. Sie können nach Rolle zuweisen oder Personen hinzufügen unter ",
    emptyTeam: "Team",
    emptyPost: ".",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    save: "Zuweisung speichern",
  },

  // ── Planung: der Kalender der kommenden Reinigungen ──
  plan: {
    title: "Reinigungsplanung",
    viewToday: "Heute",
    viewPlan: "Planung",
    loading: "Kalender wird geladen…",
    loadError: "Der Kalender konnte nicht geladen werden.",
    saveError: "Konnte nicht gespeichert werden. Bitte erneut versuchen.",
    empty: "Keine Reinigungen in diesem Zeitraum.",
    space: "Bereich",
    prev: "Vorherige Tage",
    next: "Nächste Tage",
    today: "Heute",
    days: "{n} Tage",
    anyone: "Beliebig",
    unassigned: "Nicht zugewiesen",
    headline: {
      nothing: "In diesem Zeitraum steht nichts offen.",
      all: "{total} offene Reinigungen · {urgentes} dringend",
      withOrphans: "{total} offen · {urgentes} dringend · {sin} nicht zugewiesen",
    },
    types: {
      turnover: "Abreise und Anreise",
      arrastre: "Überfällig",
      salida: "Abreise",
      estancia: "Langer Aufenthalt",
      manual: "Manuell markiert",
    },
    abbr: { all: "ALLE", turnover: "WECH", arrastre: "ÜBF", salida: "AB", estancia: "AUF", manual: "MAN" },
    windowGuessed: "Standardzeiten: diese Unterkunft hat keine eigenen hinterlegt",
    legendTight: "Knappe Zeit zwischen Abreise und Anreise",
    noRoomTip: "{n} Abreisen noch ohne zugewiesenes Zimmer",
    windowTip: "Zwischen Abreise ({desde}) und Anreise ({hasta}) liegen {min} Minuten",
    roleShort: "ROLLE",
    roleFull: "Einer Rolle zugewiesen, nicht einer Person",
    fromSpace: "feste Zuweisung des Bereichs",
    nobody: "Nicht zugewiesen — zum Auswählen klicken",
    dow: { mon: "M", tue: "D", wed: "M", thu: "D", fri: "F", sat: "S", sun: "S" },

    teamRows: "Auslastung des Teams",

    teamTitle: "Team",
    capacity: "Kapazität",
    capacityTitle: "Wie viele Reinigungen jede Person pro Tag schafft",
    done: "Fertig",
    perDay: "Pro Tag",
    dayOffTip: "Als freien Tag markieren",
    noStaff: "Du hast noch kein Reinigungspersonal. Füge Personen unter Team hinzu, dann erscheint hier ihre Auslastung.",
    shortHands: "Zu wenig Personal: {dias}",
    loadTip: "{dia}: {n} von {cap}",
    loadTipOff: "{dia}: freier Tag ({n} zugewiesen)",
    hasNow: "{n} zugewiesen · schafft {cap} pro Tag",

    selected: "{n} ausgewählt",
    assignTo: "Zuweisen an…",
    assignBtn: "{n} zuweisen",
    people: "Personen",
    noteTitle: "Notiz zu dieser Reinigung",
    notePlaceholder: "Kommt spät, bitte vorziehen…",
    unassign: "Entfernen",
    clear: "Auswahl aufheben",
    assigned: "{n} Reinigungen zugewiesen",
    unassigned2: "Zuweisung entfernt",
    partial: "{n} zugewiesen, {mal} nicht möglich",
    autoAssign: "Automatisch verteilen",
    nothingToAssign: "In diesem Zeitraum ist nichts offen zugewiesen.",
    proposalTitle: "Vorschlag zur Verteilung",
    proposalSub: "{n} Reinigungen verteilt. Vor dem Anwenden prüfen.",
    proposalApply: "Verteilung anwenden",
    proposalUncovered: "{n} nicht abgedeckt",
    cancel: "Abbrechen",
    uncovered: {
      nadie_tiene_esta_propiedad: "niemandem ist diese Unterkunft zugewiesen",
      nadie_trabaja_ese_dia: "an diesem Tag arbeitet niemand",
      equipo_lleno: "das Team ist am Limit",
    },
    rejected: {
      espacio_ajeno: "Dieser Bereich gehört nicht zu deinem Konto.",
      persona_ajena: "Diese Person gehört nicht zu deinem Team.",
      persona_sin_la_propiedad: "Dieser Person ist diese Unterkunft nicht zugewiesen. Weise sie zuerst unter Team zu.",
      rol_desconocido: "Diese Rolle existiert nicht.",
      datos_incompletos: "Es fehlen Angaben zur Reinigung.",
      error_al_guardar: "Konnte nicht gespeichert werden.",
    },
    autoAssignN: "{n} verteilen",
    seeDay: "Tag ansehen",
    filtering: "Gefiltert nach",
    showingOf: "{n} von {total} sichtbar",
    emptyFiltered: "Keine Treffer mit diesen Filtern. In diesem Zeitraum gibt es {total} Reinigungen.",
    moreFilters: "Mehr Filter",
    roomy: "Komfort",
    dense: "Kompakt",
    ofN: "von {n} Reinigungen",
    addPerson: "Jemanden zum Team hinzufügen",
    notCleaner: "Kein Reinigungspersonal, hat aber Arbeit zugewiesen",
    teamCap: "{n} pro Tag",
    teamFoot: "Die Auslastung gilt für den ganzen Zeitraum; Filter ändern sie nicht.",
    perDayN: "{n} pro Tag",
    closedN: "{n} abgeschlossen",
    capMax: "Das Maximum sind {n} pro Tag",
    rowHint: "Alt + Klick für die ganze Zeile",
    daySheetTip: "Klicken für den Tag · Alt + Klick wählt ihn ganz aus",
    keysHint: "1-9 zuweisen · A öffnen · Esc leeren",
    undo: "Rückgängig",
    undone: "Verteilung wiederhergestellt",
    tightDay: "{dia} hat {n} Reinigungen",
    tightMore1: "und 1 weiterer Tag",
    tightMoreN: "und {n} weitere Tage",
    proposalDetail: "Verteilung Reinigung für Reinigung ansehen",
    nobody2: "Noch niemand",
    warnDayOff: "{quien} hat am {dia} frei.",
    warnOver: "{quien} kommt am {dia} auf {n} und schafft {cap}.",
    onDay: "{dia}: {n} + {mas} von {cap}",
    onDays: "{dias} Tage: {n} von {cap}",
    c: { pending: "Offen", urgent: "Dringend", tight: "Enge Tage", done: "Erledigt", noRoom: "Ohne Zimmer" },
    rows: {
      withWork: "mit Arbeit",
      all: "alle",
      help: "„Alle\" zeigt auch die Bereiche, die in diesem Zeitraum nicht gereinigt werden müssen.",
      forced: "Mit aktivem Filter werden nur Bereiche mit Arbeit angezeigt.",
    },
    f: {
      any: "Beliebig",
      urgency: "Dringlichkeit",
      window: "Zeitfenster",
      state: "Status",
      unitType: "Art des Bereichs",
      clear: "Filter leeren",
    },
    urg: {
      urgente: "An dem Tag reist jemand an",
      alta: "Am nächsten Tag reist jemand an",
      normal: "In 2-3 Tagen reist jemand an",
      baja: "Danach kommt niemand",
    },
    holg: { amplia: "Reichlich", justa: "Knapp", imposible: "Zeit reicht nicht" },
    estados: { pendiente: "Offen", en_curso: "In Arbeit", hecha: "Erledigt", fuera_de_servicio: "Außer Betrieb" },
    motivos: {
      faltan_manos: "{n} zu wenig Hände",
      con_hora_limite: "{n} mit fester Frist",
      varios_edificios: "{n} verschiedene Gebäude",
    },
    sheet: {
      autoDay: "Diesen Tag verteilen",
      assignAll: "Alle {n} zuweisen",
      nCleanings: "{n} Reinigungen",
      nUnassigned: "{n} nicht zugewiesen",
      covers: "das Team schafft {n}",
      empty: "An diesem Tag gibt es nichts zu reinigen.",
    },
    tip: {
      outIn: "Abreise · Anreise",
      lateSold: "späte Abreise verkauft",
      earlySold: "frühe Anreise",
      noName: "Ohne Namen",
      pax: "{n} Pers.",
      nights: "{n} Nächte",
      min: "{n} Min",
      h: "{h} Std",
      hm: "{h} Std {m}",
      stillIn: "wohnt noch",
      freeNobody: "bleibt frei",
      freeNone: "jemand reist an",
      freeDay1: "1 Tag frei",
      freeDaysN: "{n} Tage frei",
      houseHours: "Standardzeiten",
      openSpace: "Bereichsdetails", openSpaceHint: "Öffnet sich im Heute-Board, mit Status, Aufgaben und Verlauf",
      select: "Auswählen",
      deselect: "Aus der Auswahl nehmen",
      assignedBy: "Zugewiesen von {quien}",
    },
  },
};
